import { Component, OnInit, ViewChild, Renderer } from '@angular/core';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { ValidationService } from '../../../../../../shared/_services/validation.service';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { HcaBrandService } from '../../../../../../shared/_services/hca-brand.service';
import { MarketingService } from '../../../../../../shared/_services/marketing.service';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../../../../../../shared/_services/http.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subject } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { Router } from '@angular/router';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

@Component({
  selector: 'app-hotel-brand-add',
  templateUrl: './hotel-brand-add.component.html',
  styleUrls: ['./hotel-brand-add.component.scss']
})

export class HotelBrandAddComponent implements OnInit {
  LanguageError: boolean;
  adminTerm$: any;
  brandTerm$: any;
  hotels: any[];
  hcaRoles: any;
  loyaltyAdmin: FormGroup;
  imageUrl: SafeResourceUrl;
  tagInputText: string;
  dateRepeated: boolean = false;
  isDatesRepeated: boolean = false;
  languages: any;
  selectedBrandIndex: any = 0;
  selectedBrand: any;
  loyaltyBrand: FormGroup;
  currencies: any;
  travelAgentMemberType: FormGroup;
  employeeMemberProgramType: FormGroup;
  consumerMemberProgramType: FormGroup;
  loyalty2Form: FormGroup;
  travelAgentType: FormGroup;
  employeeProgramType: FormGroup;
  consumerProgramType: FormGroup;
  selectedProgramTypes: any[];
  formData: any;
  bookingTypes: any;
  programTypes: any;
  errorDetails: string = "";
  loyalty: any = FormGroup;
  errorUpload: boolean;
  imageFile: any;
  hotel: any = FormGroup;
  items = [];
  transactionTypes: any[] = [];
  employeePointRules: any[] = [];
  searchTerm$ = new Subject<string>();
  bsConfig: Partial<BsDatepickerConfig> = { containerClass: 'theme-orange' };
  hotelTags: (text: string) => Observable<Response>;
  statusModal: BsModalRef;
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    editableDateField: false,
    inline: false,
    disableUntil: {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1},
    openSelectorOnInputClick: true
  };
  @ViewChild('uploadLogoFile') uploadLogoFile: any;
  @ViewChild('uploadFavFile') uploadFavFile: any;
  @ViewChild('uploadBannerFile') uploadBannerFile: any;
  @ViewChild('consumerProgram') consumerProgramEle: any;
  @ViewChild('employeeProgram') employeeProgramEle: any;
  @ViewChild('travelAgent') travelAgentEle: any;
  @ViewChild('consumerContentProgram') consumerContentProgramEle: any;
  @ViewChild('employeeContentProgram') employeeContentProgramEle: any;
  @ViewChild('travelContentAgent') travelContentAgentEle: any;

  @ViewChild('consumerMemberProgram') consumerMemberProgramEle: any;
  @ViewChild('employeeMemberProgram') employeeMemberProgramEle: any;
  @ViewChild('travelAgentMember') travelAgentMemberEle: any;
  @ViewChild('consumerMemberContentProgram') consumerMemberContentProgramEle: any;
  @ViewChild('employeeMemberContentProgram') employeeMemberContentProgramEle: any;
  @ViewChild('travelAgentContentMember') travelAgentContentMemberEle: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private sanitizer: DomSanitizer,
    public modalService: BsModalService,
    private validationService: ValidationService,
    private hcaUserManagementService: HcaUserManagementService,
    private marketingService: MarketingService,
    private utilService: UtilService,
    private loyaltyService: LoyaltyService,
    private hcaBrandService: HcaBrandService,
    private router: Router,
    private renderer: Renderer
  ) {
    this.hotelTags = (text: string): Observable<Response> => {
      const url = `/hotel/getHotelTags/hotel/${text}`;
      return this.http
        .get(url).debounceTime(300)
        .distinctUntilChanged()
        .map(data => {
          if (data.json().error == 0) {
            if (data.json().responseObj.length) {
              return data.json().responseObj
            } else {
              this.tagInputText = "";
            }
          }
        });
    }

    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.type == "hca-wizard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              this.router.navigate(['/hotel-management']);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-remove") {
            if (this.statusModal.content.srcObject.action == "action1") {
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              const type = this.statusModal.content.srcObject.type2;
              
              this.removeControl(form, control, i, type);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-image") {
            if (this.statusModal.content.srcObject.action == "action1") {
              // this.loyaltyBrand.get("brandsList").get(this.selectedBrandIndex).get("logoUrl").patchValue(null);
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              const type = this.statusModal.content.srcObject.type2;
              const imageType = this.statusModal.content.srcObject.imageType;
              this.removeImage(form, control, i, type, imageType);
            }
          }
        }
      })
  }



  fileChanged(event: any, type?, ctrl?, brandIdx?, hotelIdx?) {

    const brandCtrl = <FormArray>this.loyaltyBrand.controls['brandsList'];
    const brandIdxCtrl = brandCtrl.at(brandIdx);
    const hotelCtrl = <FormArray>brandCtrl.at(brandIdx).get('hotelsList');
    const hotelIdxCtrl = hotelCtrl.at(hotelIdx);

    let image = URL.createObjectURL(event.target.files[0]);

    let fileList: FileList = event.target.files;
    this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image);
    this.imageFile = event.target.files[0];
    if (ctrl == 'brand') {
      if (type == 'logo') {
        brandIdxCtrl.get('logoError').patchValue(false);
        brandIdxCtrl.get('logoSizeError').patchValue(false);
        this.removeImage(brandIdxCtrl, brandIdx, brandIdx, ctrl, type);
      } else if (type == 'favicon') {
        brandIdxCtrl.get('favError').patchValue(false);
        brandIdxCtrl.get('favSizeError').patchValue(false);
        this.removeImage(brandIdxCtrl, brandIdx, brandIdx, ctrl, type);
      }
    } else {
      hotelIdxCtrl.get('bannerError').patchValue(false);
      hotelIdxCtrl.get('bannerSizeError').patchValue(false);
      this.removeImage(hotelIdxCtrl, hotelIdx, brandIdx, ctrl, type);
    }
    this.errorUpload = false;
    if (fileList.length > 0 && (this.imageFile.type === 'image/png' || this.imageFile.type === 'image/jpg' || this.imageFile.type === 'image/jpeg')) {
      if(this.imageFile.size >= 1048576) {
        if (ctrl == 'brand') {
          if (type == 'logo') {
            brandIdxCtrl.get('logoSizeError').patchValue(true);
            this.resetFileInput('uploadLogoFile');
            setTimeout(() => {
              brandIdxCtrl.get('logoSizeError').patchValue(false);
            }, 1500);
          } else if (type == 'favicon') {
            brandIdxCtrl.get('favSizeError').patchValue(true);
            this.resetFileInput('uploadFavFile');
            setTimeout(() => {
              brandIdxCtrl.get('favSizeError').patchValue(false);
            }, 1500);
          }
        } else {
          hotelIdxCtrl.get('bannerSizeError').patchValue(true);
          this.resetFileInput('uploadBannerFile');
          setTimeout(() => {
            hotelIdxCtrl.get('bannerSizeError').patchValue(false);
          }, 1500);
        }
        this.errorUpload = true;  
      } else {
        if (ctrl == 'brand') {
          if (type == 'logo') {
            brandIdxCtrl.get('logoError').patchValue(false);
            brandIdxCtrl.get('logoSizeError').patchValue(false);
          } else if (type == 'favicon') {
            brandIdxCtrl.get('favError').patchValue(false);
            brandIdxCtrl.get('favSizeError').patchValue(false);
          }
        } else {
          hotelIdxCtrl.get('bannerError').patchValue(false);
          hotelIdxCtrl.get('bannerSizeError').patchValue(false);
        }
        this.errorUpload = false;
      }
    } else {
      if (ctrl == 'brand') {
        if (type == 'logo') {
          brandIdxCtrl.get('logoError').patchValue(true);
          this.resetFileInput('uploadLogoFile');
          setTimeout(() => {
            brandIdxCtrl.get('logoError').patchValue(false);
          }, 1500);
        } else if (type == 'favicon') {
          brandIdxCtrl.get('favError').patchValue(true);
          this.resetFileInput('uploadFavFile');
          setTimeout(() => {
            brandIdxCtrl.get('favError').patchValue(false);
          }, 1500);
        }
      } else {
        hotelIdxCtrl.get('bannerError').patchValue(true);
        this.resetFileInput('uploadBannerFile');
        setTimeout(() => {
          hotelIdxCtrl.get('bannerError').patchValue(false);
        }, 1500);
      }
      this.errorUpload = true;
    }
    let formData: any = new FormData();
    if (this.imageFile) {
      let fileName = this.imageFile.name ? this.utilService.getModifiedString(this.imageFile.name) : this.utilService.getRandomInt(0, 1000000);
      formData.append('image', this.imageFile, fileName);
    } else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('image', file, null);
    }
    if(!this.errorUpload) {
      this.utilService.uploadFile(formData).subscribe((res) => {
        if (res.error == 0) {
          if (ctrl == 'brand') {
            if (type == 'logo') {
              brandIdxCtrl.get('brandLogoName').patchValue(this.imageFile.name);
              brandIdxCtrl.get('brandLogo').patchValue(res.responseObj);
              brandIdxCtrl.get('logoUrl').patchValue(this.imageUrl);
              this.resetFileInput('uploadLogoFile');
            } else if (type == 'favicon') {
              brandIdxCtrl.get('faviconName').patchValue(this.imageFile.name);
              brandIdxCtrl.get('favicon').patchValue(res.responseObj);
              brandIdxCtrl.get('favUrl').patchValue(this.imageUrl);
              this.resetFileInput('uploadFavFile');
            }
          } else {
            hotelIdxCtrl.get('bannerName').patchValue(this.imageFile.name);
            hotelIdxCtrl.get('banner').patchValue(res.responseObj);
            hotelIdxCtrl.get('bannerUrl').patchValue(this.imageUrl);
            this.resetFileInput('uploadBannerFile');
          }
        } else {
          if (ctrl == 'brand') {
            if (type == 'logo') {
              this.resetFileInput('uploadLogoFile');
            } else if (type == 'favicon') {
              this.resetFileInput('uploadFavFile');
            }
          } else {
            this.resetFileInput('uploadBannerFile');
          }
          this.errorDetails = "Error while Uploading image";
        }
      }, error => {
        this.errorDetails = error.message;
        if (ctrl == 'brand') {
          if (type == 'logo') {
            this.resetFileInput('uploadLogoFile');
          } else if (type == 'favicon') {
            this.resetFileInput('uploadFavFile');
          }
        } else {
          this.resetFileInput('uploadBannerFile');
        }
        console.log('========res ===========', error);
      })
    }

  }

  goBack() {
    window.history.back();
  }
  cancel() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-wizard',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to cancel out of configuring hotel chain details?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      style: 'active'
    }
  }  
  deleteImage(form, control, i, type2, imageType) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      form: form,
      control: control,
      i: i,
      type2: type2,
      imageType: imageType

    }
  }

  parseBrandDates(brandsList) {
    if(brandsList && brandsList.length) {
      brandsList.forEach(brand => {
        if(brand.hotelsList && brand.hotelsList.length) {
          brand.hotelsList.forEach(hotel => {
            hotel = this.utilService.parseDate(hotel, 'seasonsList', ['dateFrom', 'dateTo']);
          });
        }
      })
      return brandsList;
    }

  }

  saveWizard(from?, to?) {
    this.formData = {
      programmeName: this.loyalty.value.programmeName,
      hotelChainId: JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId,
      programTypeList: [],
      brandsList: [],
      adminsList: []
    }

    if (from == 'doneStep1') {
      document.querySelector('wizard-navigation-bar ul.steps-indicator li').classList.add('step-done');
    }

    if(from == 'brandsList') {
      this.loyaltyBrand.value.brandsList = this.parseBrandDates(this.loyaltyBrand.value.brandsList) ? this.parseBrandDates(this.loyaltyBrand.value.brandsList) : [];
    }


    if (from == 'saveLoyalty') {
      this.consumerProgramType.value.bookingTypeList = [];
      this.employeeProgramType.value.bookingTypeList = [{
        costOfBooking: this.employeeProgramType.value.bookingPoints,
        pointsRuleId: this.employeeProgramType.value.pointsRuleId,
        referralPoints: this.employeeProgramType.value.referralPoints,
        bookingTypeTo: null
      }];
      this.travelAgentType.value.bookingTypeList = [{
        costOfBooking: this.travelAgentType.value.bookingPoints,
        bookingTypeTo: null
      }];;
      this.consumerProgramType.value.membershipLevelToList = [];
      this.employeeProgramType.value.membershipLevelToList = [];
      this.travelAgentType.value.membershipLevelToList = [];
      this.loyalty.controls['bookingType'].value.forEach(bookingValue => {
        if (bookingValue == 1) {
          this.consumerProgramType.value.directBooking = this.consumerProgramType.value.directBooking.bookingTypeTo ? this.consumerProgramType.value.directBooking : Object.assign(this.consumerProgramType.value.directBooking.points, this.consumerProgramType.value.directBooking.guests);
          this.consumerProgramType.value.directBooking.bookingTypeTo = {
            bookingType: "Direct",
            bookingTypeId: 1
          };
          this.consumerProgramType.value.bookingTypeList.push(this.consumerProgramType.value.directBooking);
        }
        if (bookingValue == 2) {
          this.consumerProgramType.value.externalBooking = this.consumerProgramType.value.externalBooking.bookingTypeTo ? this.consumerProgramType.value.externalBooking : Object.assign(this.consumerProgramType.value.externalBooking.points, this.consumerProgramType.value.externalBooking.guests);
          this.consumerProgramType.value.externalBooking.bookingTypeTo = {
            bookingType: "External",
            bookingTypeId: 2
          };
          this.consumerProgramType.value.bookingTypeList.push(this.consumerProgramType.value.externalBooking);
        }
      })
      
      this.consumerProgramType.value.membershipLevelToList = this.utilService.cleanArray(this.consumerMemberProgramType.value.membershipLevelToList.map(member => {
        if (member.isCostToJoin) {
          member.currencyType = this.currencies.filter(currency => currency.currencyId == member.currencyType)[0];
          return member;
        } else {
          return member;
        }
      }))
      this.employeeProgramType.value.membershipLevelToList = this.utilService.cleanArray(this.employeeMemberProgramType.value.membershipLevelToList.map(member => {
        if (member.isCostToJoin) {
          member.currencyType = this.currencies.filter(currency => currency.currencyId == member.currencyType)[0];
          return member;
        } else {
          return member;
        }
      }));
      // this.travelAgentType.value.membershipLevelToList = this.utilService.cleanArray(this.travelAgentMemberType.value.membershipLevelToList.map(member => {
      //   if (member.isCostToJoin) {
      //     member.currencyType = this.currencies.filter(currency => currency.currencyId == member.currencyType)[0];
      //     return member;
      //   } else {
      //     return member;
      //   }
      // }));
      // this.employeeProgramType.value.membershipLevelToList = [this.employeeMemberProgramType.value];
      this.travelAgentType.value.membershipLevelToList = [this.travelAgentMemberType.value];

      this.loyalty.controls['programType'].value.forEach(value => {
        if (value == 1) {
          this.formData.programTypeList.push(this.consumerProgramType.value);
        }
        if (value == 2) {
          this.formData.programTypeList.push(this.employeeProgramType.value);
        }
        if (value == 3) {
          this.formData.programTypeList.push(this.travelAgentType.value);
        }
      })

      this.formData.brandsList = this.loyaltyBrand.value.brandsList;
      this.formData.adminsList = this.loyaltyAdmin.value.adminsList;



      this.loyaltyService.createLoyalty(this.formData).subscribe(res => {
        this.router.navigate(['/hotel-management']);
      }, err => {
        console.error('================res============', err);
        this.errorDetails = err.message;
      })
    }
  }

  setTransactionTypes(ctrl, data) {
    let transactionForm = this[ctrl].get('transactionTypesData') as FormArray;
    transactionForm.push(this.fb.group({
      id: [data ? data.id : null],
      points: [data ? data.points : null],
      isEnabled: [data ? data.isEnabled : null],
      transactionTypeEn: [data ? data.transactionTypeEn : null],
      transactionTypeEs: [data ? data.transactionTypeEs : null],
    }));
  }

  getTransactionTypes() {
    this.marketingService.getTransactionTypes().subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj && res.responseObj.length) {
          this.transactionTypes = res.responseObj;
        } else {
          this.transactionTypes = [];
        }
      }
    }, err => {
      this.transactionTypes = [];
      console.error('Error while fetching Scratch code: ', err.message);
    })
  }

  getEmployeePointRules() {
    this.loyaltyService.getEmployeePointRules().subscribe(res => {
      if (res.error == 0) {
        if(res.responseObj && res.responseObj.length) {
          this.employeePointRules = res.responseObj;
        } else {
          this.employeePointRules = [];
        }
      }
    }, err => {
      this.employeePointRules = [];
      console.error('Error while fetching Employee Point Rules: ', err.message);
    })
  }

  getEmployeePointsTypeName(ruleId) {
    let ruleName;
    this.employeePointRules.forEach((rule, idx) => {
      if(rule.id == ruleId) {
        ruleName = rule.ruleName;
      }
    })
    return ruleName;
  }

  getProgramTypes() {
    this.loyaltyService.getProgramTypes().subscribe(res => {
      if (res.error == 0) {
        this.programTypes = res.responseObj;
      }
    })
  }

  getBookingTypes() {
    this.loyaltyService.getBookingTypes().subscribe(res => {
      if (res.error == 0) {
        this.bookingTypes = res.responseObj;
      }
    })
  }

  getCurrencyTypes() {
    this.marketingService.getCurrencyTypes()
      .subscribe(
        res => {
          if (res.error == 0) {
            this.currencies = res.responseObj;
          }
          else {
            console.error("get currency :" + res.message);
          }
        },
        err => {
          console.error(err);
        });
  }

  getLanguageCodes() {
    this.hcaBrandService.getLanguageCodes().subscribe(
      res => {
        if (res.error == 0) {
          this.languages = res.responseObj;
          if (res.responseObj.length > 0) {
          }
        }
        else {
          console.error("Get Languages : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  getRolesForHCA() {
    this.hcaUserManagementService.getRolesForHCA().subscribe(
      res => {
        if (res.error == 0) {
          this.hcaRoles = res.responseObj;
        }
        else {
          console.error("Get Admin Roles : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  setActiveTab(formControl) {
    if (formControl.value.sort().indexOf(1) == 0) {
      this.consumerProgramEle.nativeElement.classList.add('active');
      this.employeeProgramEle.nativeElement.classList.remove('active');
      this.travelAgentEle.nativeElement.classList.remove('active');
      this.consumerContentProgramEle.nativeElement.classList.add('active');
      this.employeeContentProgramEle.nativeElement.classList.remove('active');
      this.travelContentAgentEle.nativeElement.classList.remove('active');

      this.consumerMemberProgramEle.nativeElement.classList.add('active');
      this.employeeMemberProgramEle.nativeElement.classList.remove('active');
      this.travelAgentMemberEle.nativeElement.classList.remove('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.add('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.remove('active');
      this.travelAgentContentMemberEle.nativeElement.classList.remove('active');

    }
    if (formControl.value.sort().indexOf(2) == 0) {
      this.consumerProgramEle.nativeElement.classList.remove('active');
      this.employeeProgramEle.nativeElement.classList.add('active');
      this.travelAgentEle.nativeElement.classList.remove('active');
      this.consumerContentProgramEle.nativeElement.classList.remove('active');
      this.employeeContentProgramEle.nativeElement.classList.add('active');
      this.travelContentAgentEle.nativeElement.classList.remove('active');

      this.consumerMemberProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberProgramEle.nativeElement.classList.add('active');
      this.travelAgentMemberEle.nativeElement.classList.remove('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.add('active');
      this.travelAgentContentMemberEle.nativeElement.classList.remove('active');
    }
    if (formControl.value.sort().indexOf(3) == 0) {
      this.consumerProgramEle.nativeElement.classList.remove('active');
      this.employeeProgramEle.nativeElement.classList.remove('active');
      this.travelAgentEle.nativeElement.classList.add('active');
      this.consumerContentProgramEle.nativeElement.classList.remove('active');
      this.employeeContentProgramEle.nativeElement.classList.remove('active');
      this.travelContentAgentEle.nativeElement.classList.add('active');

      this.consumerMemberProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberProgramEle.nativeElement.classList.remove('active');
      this.travelAgentMemberEle.nativeElement.classList.add('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.remove('active');
      this.travelAgentContentMemberEle.nativeElement.classList.add('active');
    }
  }

  setTransactionValidations(isChecked? : boolean, ctrl?, idx?) {
    let transactionFormCtrl = <FormArray>this[ctrl].controls['transactionTypesData']
    if(isChecked) {
      // transactionFormCtrl.at(idx).get('isEnabled').patchValue(true, { emitEvent: false });
      transactionFormCtrl.at(idx).get('points').setValidators([Validators.required]);
      transactionFormCtrl.at(idx).get('points').updateValueAndValidity();
    } else {
      // transactionFormCtrl.at(idx).get('isEnabled').patchValue(false, { emitEvent: false });
      transactionFormCtrl.at(idx).get('points').patchValue(null, { emitEvent: false });
      transactionFormCtrl.at(idx).get('points').setValidators(null);
      transactionFormCtrl.at(idx).get('points').updateValueAndValidity();
    }

  }

  // Wizard Form Control  functions
  addFormControl(control, type, isChecked?: boolean) {
    if (control == 'programType') {
      this.consumerProgramEle.nativeElement.classList.remove('active');
      this.employeeProgramEle.nativeElement.classList.remove('active');
      this.travelAgentEle.nativeElement.classList.remove('active');
      this.consumerContentProgramEle.nativeElement.classList.remove('active');
      this.employeeContentProgramEle.nativeElement.classList.remove('active');
      this.travelContentAgentEle.nativeElement.classList.remove('active');

      this.consumerMemberProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberProgramEle.nativeElement.classList.remove('active');
      this.travelAgentMemberEle.nativeElement.classList.remove('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.remove('active');
      this.travelAgentContentMemberEle.nativeElement.classList.remove('active');
    }
    const formControl = <FormArray>this.loyalty.controls[control];
    if (isChecked) {
      formControl.push(new FormControl(type[control == 'programType' ? 'loyaltyProgramTypeId' : 'bookingTypeId']));
      if (control == 'programType') {
        let typeArray = ['consumerProgramType', 'employeeProgramType', 'travelAgentType'];
        if(type.loyaltyProgramTypeId == 1) {
          this.transactionTypes.forEach(type => {
              this.setTransactionTypes('consumerProgramType', type);
          })
        }
        if(type.loyaltyProgramTypeId == 2) {
          this.transactionTypes.forEach(type => {
              this.setTransactionTypes('employeeProgramType', type);
          })
        }
        if(type.loyaltyProgramTypeId == 3) {
          this.transactionTypes.forEach(type => {
              this.setTransactionTypes('travelAgentType', type);
          })
        } 
        this.setActiveTab(formControl);
      }
    } else {
      if (control == 'programType') {
        if (type.loyaltyProgramTypeId == 1) {
          let consumerForm = <FormArray>this.consumerProgramType.controls['transactionTypesData'];
          while (this.consumerProgramType.controls['transactionTypesData'].value.length !== 0) {
            consumerForm.removeAt(0);
          }
          while (this.loyalty.controls['bookingType'].value.length !== 0) {
            this.loyalty.controls['bookingType'].removeAt(0)
          }
        }
        if(type.loyaltyProgramTypeId == 2) {
          let employeeForm = <FormArray>this.employeeProgramType.controls['transactionTypesData'];
          while (this.employeeProgramType.controls['transactionTypesData'].value.length !== 0) {
            employeeForm.removeAt(0);
          }
        }
        if(type.loyaltyProgramTypeId == 3) {
          let travelForm = <FormArray>this.travelAgentType.controls['transactionTypesData'];
          while (this.travelAgentType.controls['transactionTypesData'].value.length !== 0) {
            travelForm.removeAt(0);
          }
        }
      }

      let index = formControl.controls.findIndex(x => x.value == type[control == 'programType' ? 'loyaltyProgramTypeId' : 'bookingTypeId']);
      formControl.removeAt(index);
      if (control == 'programType') {
        this.setActiveTab(formControl);
      }
    }
  }

  setBookingValidators(key) {
    const bookingCtrl = (<any>this.consumerProgramType).controls[key];
    Object.keys(bookingCtrl.controls).forEach(key => {
      if (key == 'points') {
        Object.keys(bookingCtrl.controls[key].controls).forEach(subKey => {
          bookingCtrl.controls[key].controls[subKey].setValidators([Validators.required, Validators.max(100), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
          bookingCtrl.controls[key].controls[subKey].updateValueAndValidity();
        });
      } else {
        bookingCtrl.controls[key].setValidators(this.validationService.validateCheckboxes);
        bookingCtrl.controls[key].updateValueAndValidity();
      }
    });
  }

  clearBookingValidators(key) {
    const bookingCtrl = (<any>this.consumerProgramType).controls[key];
    bookingCtrl.reset({ onlySelf: true, emitEvent: false });
    Object.keys(bookingCtrl.controls).forEach(key => {
      if (key == 'points') {
        Object.keys(bookingCtrl.controls[key].controls).forEach(subKey => {
          bookingCtrl.controls[key].controls[subKey].setValidators(null);
          bookingCtrl.controls[key].controls[subKey].updateValueAndValidity();
        });
      } else {
        bookingCtrl.controls[key].setValidators(null);
        bookingCtrl.controls[key].updateValueAndValidity();
      }
    });
  }

  setProgramValidators(ctrl, validateArr, isValidate) {
    const programCtrl = (<any>this[ctrl]);
    if (isValidate) {
      if (ctrl == 'consumerMemberProgramType' || ctrl == 'employeeMemberProgramType') {
        programCtrl.controls['membershipLevelToList'].controls.forEach((key, i) => {
          validateArr.forEach((element, idx) => {
            if(element == 'perkConfig') {
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].controls.forEach(value => {
                value.setValidators([Validators.required]);  
                value.updateValueAndValidity();
              })
            }
            programCtrl.controls['membershipLevelToList'].at(i).controls[element].setValidators([Validators.required]);
            programCtrl.controls['membershipLevelToList'].at(i).controls[element].updateValueAndValidity();
          });
        })
      } else {
        validateArr.forEach(key => {
          if (key == 'buyerPoints' || key == 'bookingPoints') {
            programCtrl.controls[key].setValidators([Validators.required, Validators.max(100), Validators.min(0), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
            programCtrl.controls[key].updateValueAndValidity();
          } else {
            programCtrl.controls[key].setValidators([Validators.required]);
            programCtrl.controls[key].updateValueAndValidity();
          }
        });
      }
    } else {
      if (ctrl == 'consumerMemberProgramType' || ctrl == 'employeeMemberProgramType') {
        while (programCtrl.controls['membershipLevelToList'].controls.length !== 1) {
          programCtrl.controls['membershipLevelToList'].removeAt(0)
        }
        programCtrl.controls['membershipLevelToList'].controls.forEach((key, i) => {
          // if(i < 0) {
          validateArr.forEach((element, idx) => {
            if(element == 'perkConfig') {
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].controls.forEach(value => {
                value.setValidators(null);  
                value.updateValueAndValidity();
              })
            }
            programCtrl.controls['membershipLevelToList'].reset();
            programCtrl.controls['membershipLevelToList'].at(0).get('isCostToJoin').patchValue(false, { emitEvent: false });
            programCtrl.controls['membershipLevelToList'].at(0).get('isGuestOptIn').patchValue(false, { emitEvent: false });
            programCtrl.controls['membershipLevelToList'].at(0).get('memberShipLevel').patchValue('Level 1', { emitEvent: false });
            programCtrl.controls['membershipLevelToList'].at(i).controls[element].setValidators(null);
            programCtrl.controls['membershipLevelToList'].at(i).controls[element].updateValueAndValidity();
          });
          // } else {
          //   programCtrl.controls['membershipLevelToList'].removeAt(i);
          // }      
        })
      } else {
        validateArr.forEach(key => {
          programCtrl.reset();
          if (ctrl == 'consumerProgramType') {
            programCtrl.get('programTypeName').patchValue('Consumer', { emitEvent: false });
            programCtrl.get('programTypeId').patchValue(1, { emitEvent: false });
          } else if (ctrl == 'employeeProgramType') {
            programCtrl.get('programTypeName').patchValue('Employee', { emitEvent: false });
            programCtrl.get('programTypeId').patchValue(2, { emitEvent: false });
          } else if (ctrl == 'travelAgentType') {
            programCtrl.get('programTypeName').patchValue('Travel Agent', { emitEvent: false });
            programCtrl.get('programTypeId').patchValue(3, { emitEvent: false });
          }
          if (key == 'buyerPoints' || key == 'bookingPoints') {
            programCtrl.controls[key].setValidators(null);
            programCtrl.controls[key].updateValueAndValidity();
          } else {
            programCtrl.controls[key].setValidators(null);
            programCtrl.controls[key].updateValueAndValidity();
          }
        });
      }
    }
  }

  setLoyaltyBookingValidators(isValidate?: boolean) {
    const ctrl = (<any>this.loyalty).controls.bookingType;
    if (isValidate) {
      ctrl.setValidators([Validators.required, this.validationService.minLengthArray(1)]);
      ctrl.updateValueAndValidity();
    } else {
      ctrl.setValidators(null);
      ctrl.updateValueAndValidity();
    }
  }

  subscribeProgramTypeChanges() {
    // controls
    const programTypeCtrl = (<any>this.loyalty).controls.programType;

    // initialize value changes stream
    const programTypeChanges$ = programTypeCtrl.valueChanges;

    // subscribe to the stream
    programTypeChanges$.subscribe(programType => {
      if (programType.indexOf(1) > -1 && programType.indexOf(2) > -1 && programType.indexOf(3) > -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], true);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], true);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], true);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], true);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], true);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
        this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], true);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], true);

        this.setLoyaltyBookingValidators(true);

      } else if (programType.indexOf(1) == -1 && programType.indexOf(2) > -1 && programType.indexOf(3) > -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], false);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], true);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], true);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], true);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], true);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
        this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], true);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], true);

        this.setLoyaltyBookingValidators(false);

      } else if (programType.indexOf(1) > -1 && programType.indexOf(2) == -1 && programType.indexOf(3) > -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], true);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], false);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], true);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], false);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], true);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], false);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], true);

        this.setLoyaltyBookingValidators(true);

      } else if (programType.indexOf(1) > -1 && programType.indexOf(2) > -1 && programType.indexOf(3) == -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], true);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], true);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], false);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], true);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], false);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
        this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], true);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], false);

        this.setLoyaltyBookingValidators(true);

      } else if (programType.indexOf(1) == -1 && programType.indexOf(2) == -1 && programType.indexOf(3) > -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], false);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], false);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], true);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], false);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], true);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], false);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], true);

        this.setLoyaltyBookingValidators(false);

      } else if (programType.indexOf(1) > -1 && programType.indexOf(2) == -1 && programType.indexOf(3) == -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], true);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], false);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], false);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], false);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], false);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], true);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], false);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], false);

        this.setLoyaltyBookingValidators(true);

      } else if (programType.indexOf(1) == -1 && programType.indexOf(2) > -1 && programType.indexOf(3) == -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], false);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], true);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], false);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], true);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], false);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
        this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], true);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], false);

        this.setLoyaltyBookingValidators(false);

      } else if (programType.indexOf(1) == -1 && programType.indexOf(2) == -1 && programType.indexOf(3) == -1) {

        this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints'], false);
        // this.setProgramValidators('employeeProgramType', ['bookingPoints', 'expirePoints'], false);
        // this.setProgramValidators('travelAgentType', ['bookingPoints', 'expirePoints'], false);
        this.setProgramValidators('employeeProgramType', ['bookingPoints', 'pointsRuleId'], false);
        this.setProgramValidators('travelAgentType', ['bookingPoints'], false);

        this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('travelAgentMemberType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
        // this.setProgramValidators('employeeMemberProgramType', ['noOfPointsIssuedOnEnrolling'], false);
        this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], false);

        this.setLoyaltyBookingValidators(false);

      }
    })
  }


  subscribeBookingTypeChanges() {
    // controls
    const loyaltyBookingCtrl = (<any>this.loyalty).controls.bookingType;
    const loyaltyProgramCtrl = (<any>this.loyalty).controls.programType;

    // initialize value changes stream
    const loyaltyChanges$ = loyaltyBookingCtrl.valueChanges;

    // subscribe to the stream
    loyaltyChanges$.subscribe(bookingType => {
      if (loyaltyProgramCtrl.value.indexOf(1) > -1) {
        if (bookingType.indexOf(1) > -1 && bookingType.indexOf(2) > -1) {
          this.setBookingValidators('directBooking');
          this.setBookingValidators('externalBooking');
        } else if (bookingType.indexOf(1) > -1 && bookingType.indexOf(2) == -1) {
          this.setBookingValidators('directBooking');
          this.clearBookingValidators('externalBooking');
        } else if (bookingType.indexOf(1) == -1 && bookingType.indexOf(2) > -1) {
          this.clearBookingValidators('directBooking');
          this.setBookingValidators('externalBooking');
        } else if (bookingType.indexOf(1) == -1 && bookingType.indexOf(2) == -1) {
          this.clearBookingValidators('directBooking');
          this.clearBookingValidators('externalBooking');
        }
      } else {
        this.clearBookingValidators('directBooking');
        this.clearBookingValidators('externalBooking');
      }
    });
  }

  setPointvalidators(ctrl, key, value) {
    // controls
    const pointsCtrl = (<any>this[ctrl]).controls[key];
    const pointsValueCtrl = (<any>this[ctrl]).controls[value];

    // initialize value changes stream
    const pointsChanges$ = pointsCtrl.valueChanges;
    pointsChanges$.subscribe(point => {
      if (point) {
        pointsValueCtrl.setValidators([Validators.required]);
        pointsValueCtrl.updateValueAndValidity();
      } else {
        pointsValueCtrl.patchValue(null, { emitEvent: false });
        pointsValueCtrl.setValidators(null);
        pointsValueCtrl.updateValueAndValidity();
      }
      // }
    })
  }

  subscribePointChanges() {
    let validateFormBy = ['consumerProgramType', 'employeeProgramType', 'travelAgentType'];
    let validateInputBy = {
      isBirthdayPoints: 'birthdayPoints',
      isBlogPoints: 'blogPoints',
      isInvitePoints: 'invitePoints',
      isJoinPoints: 'joinPoints',
      isSharePoints: 'sharePoints'
    }

    this.consumerProgramType.controls['buyerPoints'].valueChanges.subscribe((value: any) => {
      let total: any = 100;
      if ((value && value.length == 0) || value == undefined || value == null) {
        this.consumerProgramType.controls['guestPoints'].patchValue(null, { onlySelf: true, emitEvent: false });
      } else if (value > 100) {
        this.consumerProgramType.controls['buyerPoints'].patchValue(100, { onlySelf: true, emitEvent: false });
        this.consumerProgramType.controls['guestPoints'].patchValue(0, { onlySelf: true, emitEvent: false });
      } else {
        let finalVal: any = total - value;
        this.consumerProgramType.controls['guestPoints'].patchValue(Math.round(finalVal * 100) / 100, { onlySelf: true, emitEvent: false });
      }
    })

    this.employeeProgramType.controls['pointsRuleId'].valueChanges.subscribe(value => {
      if(value && (value == 1 || value == 2)) {
        this.employeeProgramType.controls['referralPoints'].setValidators([Validators.required, Validators.max(99999), Validators.min(0), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
        this.employeeProgramType.controls['referralPoints'].updateValueAndValidity();
      } else {
        this.employeeProgramType.controls['referralPoints'].patchValue(null, { onlySelf: true, emitEvent: false })
        this.employeeProgramType.controls['referralPoints'].setErrors(null, { emitEvent: false })
        this.employeeProgramType.controls['referralPoints'].setValidators(null);
        this.employeeProgramType.controls['referralPoints'].updateValueAndValidity();
      }
    })

    validateFormBy.forEach(ctrl => {
      Object.keys(validateInputBy).forEach(key => {
        this.setPointvalidators(ctrl, key, validateInputBy[key]);
      });
    })
  }

  subscribeMemeberCostChanges(value, formCtrl, i) {
    const formControl = <FormArray>this[formCtrl].controls['membershipLevelToList'];
    if (formControl.at(i).get('isCostToJoin').value) {
      formControl.at(i).get('costToJoin').setValidators([Validators.required, Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
      formControl.at(i).get('currencyType').setValidators([Validators.required]);
      formControl.at(i).get('costToJoin').updateValueAndValidity();
      formControl.at(i).get('currencyType').updateValueAndValidity();
    } else {
      formControl.at(0).get('costToJoin').patchValue(null);
      formControl.at(0).get('currencyType').patchValue(null);
      formControl.at(i).get('costToJoin').setValidators(null);
      formControl.at(i).get('currencyType').setValidators(null);
      formControl.at(i).get('costToJoin').updateValueAndValidity();
      formControl.at(i).get('currencyType').updateValueAndValidity();
    }
  }

  initBookingTypes() {
    return this.fb.group({
      points: this.fb.group({
        costOfBooking: [null],
        costOfExtras: [null],
        coeficient: [null]
      }),
      guests: this.fb.group({
        isSeniors: [false],
        isAdults: [false],
        isYouth: [false],
        isChild: [false],
        isInfants: [false]
      })
    })
  }

  initLoyalty1Form() {
    this.loyalty = this.fb.group({
      programmeName: [null, Validators.required],
      programType: this.fb.array([], this.validationService.minLengthArray(1)),
      bookingType: this.fb.array([], this.validationService.minLengthArray(1)),
    })
  }

  initLoyalty2Form() {
    this.consumerProgramType = this.fb.group({
      programTypeName: 'Consumer',
      programTypeId: 1,
      directBooking: this.initBookingTypes(),
      externalBooking: this.initBookingTypes(),
      buyerPoints: [null],
      guestPoints: [null],
      transactionTypesData: new FormArray([]),
      isBirthdayPoints: [false],
      birthdayPoints: [null],
      isBlogPoints: [false],
      blogPoints: [null],
      isInvitePoints: [false],
      invitePoints: [null],
      isJoinPoints: [false],
      joinPoints: [null],
      isSharePoints: [false],
      sharePoints: [null],
      expirePoints: [null]
    })

    this.employeeProgramType = this.fb.group({
      programTypeName: 'Employee',
      programTypeId: 2,
      bookingPoints: [null],
      pointsRuleId: [null],
      referralPoints: [null],
      isBirthdayPoints: [false],
      transactionTypesData: new FormArray([]),
      birthdayPoints: [null],
      isBlogPoints: [false],
      blogPoints: [null],
      isInvitePoints: [false],
      invitePoints: [null],
      isJoinPoints: [false],
      joinPoints: [null],
      isSharePoints: [false],
      sharePoints: [null],
      expirePoints: [null]
    })

    this.travelAgentType = this.fb.group({
      programTypeName: 'Travel Agent',
      programTypeId: 3,
      bookingPoints: [null],
      transactionTypesData: new FormArray([]),
      isBirthdayPoints: [false],
      birthdayPoints: [null],
      isBlogPoints: [false],
      blogPoints: [null],
      isInvitePoints: [false],
      invitePoints: [null],
      isJoinPoints: [false],
      joinPoints: [null],
      isSharePoints: [false],
      sharePoints: [null],
      expirePoints: [null]
    })
  }
  
  onColorPickerChange(colourCode: string, formControl, index): void {
    let memberShipForm = this[formControl].get('membershipLevelToList') as FormArray;
    memberShipForm.at(index).get('colourCode').setValue(colourCode);
    memberShipForm.at(index).get('colourCode').markAsDirty();
    memberShipForm.at(index).get('colourCode').markAsTouched();
  }
  
  addPerks(perkData?: any) {
    // let perkForm = new FormArray([]);
    return new FormControl(perkData ? perkData : null, Validators.required);
  }

  addMembershipLevel(formControl) {
    let memberShipForm = this[formControl].get('membershipLevelToList') as FormArray;
    let perksArray = new FormArray([]);
    [1, 2, 3, 4].forEach(perk => {
      perksArray.push(this.addPerks(null));
    })
    memberShipForm.push(this.fb.group({
      memberShipName: [null, [Validators.required]],
      memberShipLevel: [null, Validators.required],
      costToJoin: [null, Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)],
      currencyType: [null],
      isCostToJoin: [false, Validators.required],
      isGuestOptIn: [false, Validators.required],
      noOfNightsNeedToUpgrade: [null, Validators.required],
      noOfPointsIssuedOnEnrolling: [null, Validators.required],
      noOfStaysNeedToUpgrade: [null, Validators.required],
      colourCode: [null, Validators.required],
      perkConfig: perksArray,
      // noOfPointsIssuedOnReferral: [null, Validators.required]
    }, this.validationService.minLengthArray(1)))
  }

  removeControl(form, control, i, type?) {
    if (type == 'hotel' || type == 'season') {
      // const formControl = <FormArray>this[form].controls[control];
      const formControl = <FormArray>form.controls[control];
      formControl.removeAt(i);
    } else {
      const formControl = <FormArray>this[form].controls[control];
      formControl.removeAt(i);
      if(type == 'brand') {
        this.selectedBrandIndex = 0;
      }
    }
  }


  removeImage(form, control, i, type?, imageType?) {
    if (type == 'hotel') {
      if (imageType == 'banner') {

        form.get('bannerUrl').patchValue(null, { emitEvent: false });
        form.get('bannerName').patchValue(null, { emitEvent: false });
        form.get('banner').patchValue(null, { emitEvent: false });
        form.get('bannerError').patchValue(false, { emitEvent: false });
        form.get('bannerSizeError').patchValue(false, { emitEvent: false });
      }
    } else if (type == 'brand') {
      if (imageType == 'logo') {
        form.get('brandLogoName').patchValue(null, { emitEvent: false });
        form.get('logoUrl').patchValue(null, { emitEvent: false });
        form.get('brandLogo').patchValue(null, { emitEvent: false });
        form.get('logoError').patchValue(false, { emitEvent: false });
        form.get('logoSizeError').patchValue(false, { emitEvent: false });
      } else if (imageType == 'favicon') {
        form.get('favUrl').patchValue(null, { emitEvent: false });
        form.get('faviconName').patchValue(null, { emitEvent: false });
        form.get('favicon').patchValue(null, { emitEvent: false });
        form.get('favError').patchValue(false, { emitEvent: false });
        form.get('favSizeError').patchValue(false, { emitEvent: false });
      }
    }
  }

  initLoyalty3Form() {
    let membershipLevelConsumerToList: FormArray = new FormArray([], this.validationService.uniqueBy('memberShipName'));
    let membershipLevelEmpToList: FormArray = new FormArray([], this.validationService.uniqueBy('memberShipName'));
    let membershipLevelTravelToList: FormArray = new FormArray([], this.validationService.uniqueBy('memberShipName'));
    this.consumerMemberProgramType = this.fb.group({
      programNasme: 'Consumer',
      programTypeId: 1,
      membershipLevelToList: membershipLevelConsumerToList
    })
    this.addMembershipLevel('consumerMemberProgramType');

    this.employeeMemberProgramType = this.fb.group({
      programNasme: 'Employee',
      programTypeId: 2,
      noOfPointsIssuedOnEnrolling: [null],
      membershipLevelToList: membershipLevelEmpToList
      // noOfPointsIssuedOnReferral: [null]

    })
    this.addMembershipLevel('employeeMemberProgramType');

    this.travelAgentMemberType = this.fb.group({
      programNasme: 'Travel Agent',
      programTypeId: 3,
      noOfPointsIssuedOnEnrolling: [null],
      membershipLevelToList: membershipLevelTravelToList
      // noOfPointsIssuedOnReferral: [null]
    })
    // this.addMembershipLevel('travelAgentMemberType');
    this.subscribeProgramTypeChanges();
    this.subscribePointChanges();
  }

  getBrandDetailsByBrandId(brand, i) {
    this.selectedBrand = brand;
    this.selectedBrandIndex = i;
    this.validationService.uniqueBy('brandName');
  }

  initSeason() {
    return this.fb.group({
      seasonId: [null],
      name: [null, Validators.required],
      dateTo: [null, Validators.required],
      dateFrom: [null, Validators.required],
      points: [null, Validators.required],
    }, this.validationService.minLengthArray(1))
  }

  onDateChanged(event: IMyDateModel, type, brandIdx, hotelIdx, seasonIdx) {
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    let hotelForm = brandListForm.at(brandIdx).get('hotelsList') as FormArray;
    let seasonForm = hotelForm.at(hotelIdx).get('seasonsList') as FormArray;
    seasonForm.at(seasonIdx).get(type).setValue(event.formatted);
    seasonForm.at(seasonIdx).get(type).markAsDirty();
    seasonForm.at(seasonIdx).get(type).markAsTouched();
  }

  addSeason(brandIdx, hotelIdx) {
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    let hotelForm = brandListForm.at(brandIdx).get('hotelsList') as FormArray;
    let seasonForm = hotelForm.at(hotelIdx).get('seasonsList') as FormArray;
    seasonForm.push(this.fb.group({
      seasonId: [null],
      name: [null, Validators.required],
      dateTo: [null, Validators.required],
      dateFrom: [null, Validators.required],
      points: [null, Validators.required],
    }))
  }

  initHotel() {
    let seasonsList: FormArray = new FormArray([]);
    return this.fb.group({
      hotelName: [null, Validators.compose([Validators.required])],
      brandId: [null],
      description: [null],
      hotelCode: [null, Validators.required],
      // contactEmail: [null, Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      contactEmail: [null, Validators.compose([Validators.required])],
      website: [null, Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      tags: [null],
      bannerName: [null],
      banner: [null],
      bannerUrl: [null],
      bannerError: [false],
      bannerSizeError: [false],
      isDatesRepeated: [false],
      dateRepeated: [false],
      seasonsList: this.fb.array([
        this.initSeason()
      ]),
    })
  }

  addHotel(i) {
    let seasonsList: FormArray = new FormArray([
      this.initSeason()
    ], Validators.compose([this.validationService.uniqueBy('name'), this.validationService.checkDateRange.bind(this), this.validationService.dateValidator.bind(this)]));
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    let hotelForm = brandListForm.at(i).get('hotelsList') as FormArray;
    hotelForm.push(this.fb.group({
      hotelName: [null, Validators.compose([Validators.required])],
      brandId: [null],
      description: [null],
      hotelCode: [null, Validators.required],
      // contactEmail: [null, Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      contactEmail: [null, Validators.compose([Validators.required])],
      website: [null, Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      tags: [null],
      bannerName: [null],
      banner: [null],
      bannerUrl: [null],
      bannerError: [false],
      bannerSizeError: [false],
      isDatesRepeated: [false],
      dateRepeated: [false],
      seasonsList: seasonsList,
    }))
  }

  addLoyaltyBrand() {
    let hotelsList: FormArray = new FormArray([], this.validationService.uniqueBy('hotelName'));
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    brandListForm.push(this.fb.group({
      brandId: [null],
      brandName: new FormControl(null, [Validators.required]),
      brandNameError: [false],
      website: [null, Validators.compose([Validators.required, Validators.pattern(this.validationService.webUrl_regexPattern)])],
      blogUrl: [null, Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      languageId: ["", Validators.required],
      // languagesList: this.fb.array([], this.validationService.minLengthArray(1)),
      smartCode: [null, Validators.compose([Validators.required, Validators.maxLength(4)])],
      brandLogoName: [null],
      brandLogo: [null],
      logoUrl: [null],
      logoError: [false],
      logoSizeError: [false],
      faviconName: [null],
      favicon: [null],
      favUrl: [null],
      favError: [false],
      favSizeError: [false],
      hotelChainId: [JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId],
      hotelsList: hotelsList
    }, this.validationService.minLengthArray(1)))
  }

  getHotelBrandsByHotelChain(brandName) {
    this.loyaltyBrand.controls['brandsList'].value.forEach(brand => {
      if (brand.brandName == brandName) {
        this.hotels = brand.hotelsList;
      }
    })
  }

  selectedRole(adminIdx) {
    let adminForm = <FormArray>this.loyaltyAdmin.get('adminsList');
    let adminIdxCtrl = adminForm.at(adminIdx);
    let brandIdControl = <FormArray>adminIdxCtrl.get('brandName');
    let role = adminIdxCtrl.get('roleId').value;
    let hotel = adminIdxCtrl.get('hotelName');
    let brand = adminIdxCtrl.get('brandName');
    this.hotels = [];
    hotel.enable();
    brand.enable();
    adminIdxCtrl.get('isAllBrandsSelected').patchValue(false, { emitEvent: false });
    adminIdxCtrl.get('isAllHotelsSelected').patchValue(false, { emitEvent: false });
    hotel.setValue("", { emitEvent: false });
    brand.setValue("", { emitEvent: false });
    if (role == '' || role == null) {
      brand.disable();
      hotel.disable();
      this.hotels = [];
      adminIdxCtrl.get('isAllBrandsSelected').patchValue(true, { emitEvent: false });
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
      hotel.setValue("", { emitEvent: false });
      brand.setValue("", { emitEvent: false });
    }
    if (role != 12) {
      hotel.setValue("", { emitEvent: false });
      this.hotels = [];
      this.getHotelBrandsByHotelChain(brand.value);
      if (role == 14 && brand.value) {
        hotel.enable();
        adminIdxCtrl.get('isAllHotelsSelected').patchValue(false, { emitEvent: false });
      } else {
        hotel.disable();
        this.hotels = [];
        adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
        hotel.setValue("", { emitEvent: false });
      }
    } else {
      brand.disable();
      hotel.disable();
      this.hotels = [];
      adminIdxCtrl.get('isAllBrandsSelected').patchValue(true, { emitEvent: false });
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
      hotel.setValue("", { emitEvent: false });
      brand.setValue("", { emitEvent: false });
    }
  }

  selectedBrands(adminIdx) {
    let adminForm = <FormArray>this.loyaltyAdmin.get('adminsList');
    let adminIdxCtrl = adminForm.at(adminIdx);
    let brandIdControl = <FormArray>adminIdxCtrl.get('brandName');
    let role = adminIdxCtrl.get('roleId').value;
    let hotel = adminIdxCtrl.get('hotelName');
    let brand = adminIdxCtrl.get('brandName');
    if (role && role == 14) {
      hotel.setValue("", { emitEvent: false });
      this.hotels = [];
      this.getHotelBrandsByHotelChain(brand.value);
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(false, { emitEvent: false });
      hotel.enable();
    }
    else {
      hotel.disable();
      this.hotels = [];
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
      hotel.setValue("", { emitEvent: false });
    }
  }


  templateString(type, info) {
    return `${info} ${type}${info == 1 ? '' : 's'} selected`;
  }

  getPointsArr(control, arr) {
    let pointsObj = {
      isAdults: 'Adults',
      isSeniors: 'Seniors',
      isYouth: 'Youth',
      isChild: 'Child',
      isInfants: 'Infants'
    }
    let pointsArr = [];
    Object.keys(pointsObj).forEach(point => {
      if (control.get(point).value) {
        pointsArr.push(pointsObj[point]);
      }
    })
    return pointsArr.join(', ');
  }

  resetFileInput(element?) {
    this[element].nativeElement.value = "";
  }

  addLoyaltyAdmin() {
    let adminForm = this.loyaltyAdmin.controls['adminsList'] as FormArray;
    adminForm.push(this.fb.group({
      roleId: ['', Validators.required],
      brandId: [''],
      brandName: ['', Validators.required],
      brandNames: this.fb.array([]),
      hotelId: [''],
      hotelName: ['', Validators.required],
      hotelNames: this.fb.array([]),
      isAllBrandsSelected: [false],
      isAllHotelsSelected: [false],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      // email: new FormControl(null, [Validators.required, Validators.pattern(this.validationService.email_regexPattern)]),
      email: new FormControl(null, [Validators.required]),
      // mobileNumber: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(15), Validators.pattern(this.validationService.phoneNumber_regexPattern)])],
      mobileNumber: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      skypeId: ['']
    }, this.validationService.minLengthArray(1)))
  }

  toggleSelection(language, brandIdx) {
    setTimeout(() => {
      let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
      let formControl = brandListForm.at(brandIdx).get('languagesList') as FormArray;
      let idx = formControl.controls.findIndex(x => x.value == parseInt(language.id));
      if (idx > -1) {
        // formControl.controls.splice(idx, 1);
        formControl.removeAt(idx);
      } else {
        formControl.push(new FormControl(language.id));
        // this.selectedLevels.push(parseInt(level.loyaltyId));
      }
      this.checkError(formControl);
    }, 100);
  }

  checkError(control) {
    this.errorDetails = '';
    if (!control.value.length) {
      this.LanguageError = true;
    } else {
      this.LanguageError = false;
    }
  }

  initLoyaltyBrandForm() {
    let brandsList: FormArray = new FormArray([], this.validationService.uniqueBy('brandName'));
    this.loyaltyBrand = this.fb.group({
      brandsList: brandsList
    })
    this.addLoyaltyBrand();
  }

  initLoyaltyAdminForm() {
    let adminsList: FormArray = new FormArray([], this.validationService.uniqueBy('email'));
    this.loyaltyAdmin = this.fb.group({
      adminsList: adminsList
    })
    // this.addLoyaltyAdmin();
  }

  initForm() {
    this.initLoyalty1Form();
    this.initLoyalty2Form();
    this.initLoyalty3Form();
    this.initLoyaltyBrandForm();
    this.initLoyaltyAdminForm();
  }

  get brandListArray() {
    let formArray = <FormArray>this.loyaltyBrand.controls['brandsList'];
    return formArray.at(this.selectedBrandIndex);
  }

  get hotelListControl() {
    let formArray = <FormArray>this.brandListArray.get('hotelsList');
    return formArray.controls;
  }

  remove(form, control, i, type2?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-remove',
      title: 'Confirm',
      status: 'Active',
      message: `Are you sure you want to remove ${type2}?`,
      action1: 'Remove',
      action2: 'Cancel',
      action: '',
      style: 'inactive',
      form: form,
      control: control,
      i: i,
      type2: type2
    }
  }

  ngOnInit() {
    this.initForm();
    this.getProgramTypes();
    this.getBookingTypes();
    this.getCurrencyTypes();
    this.getLanguageCodes();
    this.getTransactionTypes();
    this.getEmployeePointRules();
    this.getRolesForHCA();
    this.subscribeBookingTypeChanges();
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}


// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotel-brand-add/hotel-brand-add.component.ts